module.exports = __webpack_public_path__ + "img/PR.34a18e4b.svg";